module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAASdJREFUSEtjZKAxYKSx+QwDZ8H///8Zjcyd9BgY//z293S+0dDQ8I8c3+L0gYGxbQoDA4MT2FBGhvusjP/nnj595B6pluCxwG4hA8N/VoSBjP8ZGRl28vMwrTpw4MAPYi3C54NlWA1hZHzHyMS04PypA2eIsYR0C6CmMjIwnWFlZll46tTet/gsItsCiKFMPxkZGVb5+zjuxJUIKLQA7h2ciYA6FkCS2n8Gxv+rLpw5vBE5yKhoAcRYNma2XOR4GUoWgPPJyvNnDm2ifhDhyekUBhENkykjA+NZVmbWBdTPaIyM7xgYGRdeOH3wNGVFhYntPIb/DBw0K+yMTO0T//3750qz4rqhoYFp0/a9Ov//szD6e9lfpnqFQ0z4EqNm4OpkYlxHjBoAOtCAGU1DJGUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/visa-api/icon-arrow.png
// module id = 4ywH
// module chunks = 4